import { DATE_RANGES_KEYS, LIGHTWEIGHT_FILTERS_DEFAULT_RANGES_LABELS_MAP } from '../../constants/dateRange';
import { mapRangeVariantToDateRange } from './mapRangeVariantToDateRange';

export const getAllRanges = () => {
  return DATE_RANGES_KEYS.map((rangeVariant) => ({
    type: rangeVariant,
    label: LIGHTWEIGHT_FILTERS_DEFAULT_RANGES_LABELS_MAP[rangeVariant],
    getValue: () => mapRangeVariantToDateRange(rangeVariant),
  }));
};
